import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargeState } from 'src/app/models/charge-state';
import { SvgRecolorDirective } from 'src/app/directives/svg-recolor.directive';
import { LanguageService } from 'src/app/services/account/language.service';

/** Full-bleed gradient hero shown while the car sits at a charging station
 *  (arrived / charging / finished). Only rendered in a charge state. */
@Component({
  standalone: true,
  selector: 'app-navigation-plan-header',
  templateUrl: './navigation-plan-header.component.html',
  styleUrls: ['./navigation-plan-header.component.scss'],
  imports: [CommonModule, SvgRecolorDirective]
})
export class NavigationPlanHeaderComponent {
  @Input() chargeState: ChargeState = ChargeState.None;
  @Input() chargerName: string = '';
  public ChargeState = ChargeState;

  constructor(public languageService: LanguageService) {}

  /** Short status label shown above the arrival message in the charge hero. */
  get heroEyebrow(): string {
    switch (this.chargeState) {
      case ChargeState.ArriveToCharger:
        return this.languageService.languageJSON?.VoiceCommand_Charge ?? '';
      case ChargeState.Charging:
        return this.languageService.languageJSON?.Global_Charging ?? '';
      case ChargeState.ChargeFinish:
        return this.languageService.languageJSON?.NavigationHud_ChargingIsFinished ?? '';
      default:
        return '';
    }
  }
}
